<div class="container">
    <p class="mb-2">Informe o seu e-mail para que possamos prosseguir</p>
    <input
      class="h-3rem w-18rem m-2"
      type="email"
      pInputText
      placeholder="Email"
      [(ngModel)]="email"
    />
    <p-button label="Reenviar e-mail" *ngIf="showResendEmail" [disabled]="resendEmailDisable"
              [loading]="loading"
              (click)="resendEmail()" [link]="true"></p-button>
    <p-button
      [style]="{ width: '18rem', height: '2.5rem' }"
      class="h-2rem m-2 text-center"
      label="Enviar"
      [loading]="loading"
      (click)="sendEmail()"
    ></p-button>
</div>
